import { render, staticRenderFns } from "./rechargeDetail.vue?vue&type=template&id=51e6c4d0&scoped=true&"
import script from "./rechargeDetail.vue?vue&type=script&lang=js&"
export * from "./rechargeDetail.vue?vue&type=script&lang=js&"
import style0 from "./rechargeDetail.vue?vue&type=style&index=0&lang=css&"
import style1 from "./rechargeDetail.vue?vue&type=style&index=1&id=51e6c4d0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51e6c4d0",
  null
  
)

export default component.exports